const INSTAGRAM_URL = 'https://www.instagram.com/psycle.mx';

const PenaltyBanner = ({ onDismiss }) => (
  <div className="penalty-banner">
    <span className="penalty-banner__icon">⚠️</span>
    <span className="penalty-banner__text">
      Tienes una penalización pendiente de <strong>$100</strong>.
      Tienes <strong>24 horas</strong> para saldarla o el paquete penalizado quedará suspendido.
    </span>
    <a
      className="penalty-banner__link"
      href={INSTAGRAM_URL}
      target="_blank"
      rel="noopener noreferrer"
    >
      Contáctanos en Instagram →
    </a>
    <button className="penalty-banner__close" onClick={onDismiss} aria-label="Cerrar">
      ✕
    </button>
  </div>
);

export default PenaltyBanner;
